import script from "./SeriesDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SeriesDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SeriesDrawer.vue?vue&type=style&index=0&id=58a10c58&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a10c58"]])

export default __exports__